module.exports = __webpack_public_path__ + "logos/logo-heroku.86a7ee.svg";